// Defines main application routes

import { routes } from "./routes";

//Pages
import SamplePage from "../pages/pages/SamplePage";
import Error404 from "../components/pages/others/errorPage/Error404";
import UsersPage from "../pages/UsersPage";
import UserRegisterPage from "../pages/pages/UserRegisterPage";
import UserUpdatePage from "../pages/UserUpdatePage";
import UpdatePasswordPage from "../pages/UpdatePasswordPage";
import DistributaryZoneListPage from "../pages/DistributaryZoneListPage";
import DistributaryZoneFormPage from "../pages/DistributaryZoneForm";
import UpdateDistrbutoryZonepage from "../pages/UpdateDistrbutoryZonepage";
import SchemeVillagePage from "../pages/SchemeVillagePage";
import UpdateSchemeVillagePage from "../pages/UpdateSchemeVillagepage";
import AddSchemeVillagePage from "../pages/AddSchemeVillagePage";

import ChackPage from "../pages/ChackPage";
import UpdateChackPage from "../pages/UpdateChackPage";
import ChackInstrumentPage from "../pages/ChackInstrumentPage";
import UpdateChackInstrumentPage from "../pages/UpdateChackInstrumentPage";
import AddChackPage from "../pages/pages/AddChackPage";
import AddChackInstrumentDetailPage from "../pages/AddChackInstrument";
import EmailPage from "../pages/EmailPage";
import UpdateEmailPage from "../pages/UpdateEmail";
import AddEmailPage from "../pages/AddEmailPage";
import ChackValveDetailPage from "../pages/ChackValveDetailPage";
import UpdateChackValveDetailPage from "../pages/UpdateChackValveDetailPage";
import AddChackValveDetailPage from "../pages/AddChackValveDetailPage"; 
import KhasaraPage from "../pages/KhasaraPage";
import UpdateKhasarPage from "../pages/UpdateKhasar";
import AddKhasarPage from "../pages/AddKhasar";
import UserProfilePage from "../pages/UserProfilePage";
import FarmerPage from "../pages/FarmerPage";
import KmlPage from "../pages/KmlPage";
import UpdateKmlPage from "../pages/UpdateKmlPage";
import AddKmlPage from "../pages/AddKmlPage";

import MapViewPage from "../pages/MapViewPage";
import MapView from "../components/mapView/MapView";
import KmLLayer from "../components/mapView/KmlLayer";
import ChackComponent from "../components/mapView/ChackComponent";
import ProjectSettingsPage from "../pages/ProjectSettingsPage";
import UpdateProjectPage from "../pages/UpdateProjectPage";
import AddProjectPage from "../pages/AddProjectPage";
import OmsListPage from "../pages/OmsListPage";
import UpdateOmsPage from "../pages/UpdateOmsPage";
import AddOmsPage from "../pages/AddOmsPage";
import Dashboard from "../pages/DashboardPage";
import CheckEmail from "../auth/ForgotPassword";


import Report from "../components/reports/Report";

import AlarmsTablePage from "../pages/AlarmsTablePage";
import UpdateFarmerPage from "../pages/UpdateFarmerPage";
import AddFarmerPage from "../pages/pages/AddFarmerPages";
import BeneficiaryList from "../components/configuration/beneficiarylist/BeneficiaryList";
import AddBeneficiary from "../components/configuration/beneficiarylist/AddBeneficiary";
import UpdateBeneficiary from "../components/configuration/beneficiarylist/UpdateBeneficiary";



export const AppRoutes = [
  
  //Pages
  { path: routes.Sample, element: <SamplePage /> },
  { path: routes.Users, element: <UsersPage /> },
  { path: routes.UserRegister, element: <UserRegisterPage /> },
  { path: routes.UpdateUser, element: <UserUpdatePage /> },
  { path: routes.UpdatePassword, element: <UpdatePasswordPage /> },
   {path: routes.UserProfilePage, element: <UserProfilePage/> },
  { path: routes.DistributaryZoneForm, element: <DistributaryZoneFormPage /> },
  { path: routes.DistributaryZoneList, element: <DistributaryZoneListPage /> },
  { path: routes.DistributaryZoneUpdate, element: <UpdateDistrbutoryZonepage /> },
  
  { path: routes.SchemeVillageList, element: <SchemeVillagePage /> },
  { path: routes.SchemeVillageUpdate, element: <UpdateSchemeVillagePage /> },
  { path: routes.SchemeVillageAdd, element: <AddSchemeVillagePage /> },
  { path: routes.ChackList, element: <ChackPage /> },
  { path: routes.ChackUpdate, element: <UpdateChackPage /> },
  { path: routes.ChackInstrument, element: <ChackInstrumentPage /> },
  { path: routes.ChackInstrumentUpdate, element: <UpdateChackInstrumentPage /> },
  { path: routes.ChackAdd, element: <AddChackPage /> },
  { path: routes.AddChackInstrument, element: <AddChackInstrumentDetailPage /> },
  { path: routes.EmailList, element: <EmailPage /> },
  { path: routes.EmailUpdate, element: <UpdateEmailPage /> },
  { path: routes.AddEmail, element: <AddEmailPage /> },
  { path: routes.ChackValveDetail, element: <ChackValveDetailPage /> },
  { path: routes.UpdateChackValveDetail, element: <UpdateChackValveDetailPage /> },
  { path: routes.AddChackValveDetail, element: <AddChackValveDetailPage /> },
  { path: routes.KhasaraList, element: <KhasaraPage /> },
  { path: routes.KhasaraUpdate, element: <UpdateKhasarPage /> },
  { path: routes.AddKhasara, element: <AddKhasarPage /> },
  {path:routes.FarmerList, element: <FarmerPage/>},
  {path:routes.FarmerUpdateL, element:<UpdateFarmerPage/>},
  {path:routes.AddFarmer, element:<AddFarmerPage/>},
  {path:routes.KmlList,element:<KmlPage/>},
  {path:routes.AddKml, element:<AddKmlPage/>},
  {path:routes.UpdateKml, element:<UpdateKmlPage/>},
  {path : routes.MapView, element:<MapViewPage/>},
  //project
  {path:routes.ProjectList,element:<ProjectSettingsPage/>},
  {path:routes.ProjectUpdate,element:<UpdateProjectPage/>},
  {path:routes.ProjectAdd,element:<AddProjectPage/>},
  {path:routes.OmsList,element:<OmsListPage/>},
  {path:routes.OmsUpdate,element:<UpdateOmsPage/>},
  {path:routes.OmsAdd,element:<AddOmsPage/>},
  {path:routes.DashBoard,element:<Dashboard/>},

  
  //mqtt
  
 // {path:routes.PopUp,element:<ChackComponent/>}
   // report 
   {path:routes.report,element:<Report/>},

   //
  
   {path:routes.Alarms,element:<AlarmsTablePage/>},
   {path:routes.BeneficiaryList,element:<BeneficiaryList/>},
   {path:routes.BeneficiaryAdd,element:<AddBeneficiary/>},
   {path:routes.BeneficiaryUpdate,element:<UpdateBeneficiary/>}

];

export const AuthRoutes = [

  // Error Pages
  { path: routes.ErrorPages.Error404, element: <Error404 /> },
  
];
